var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "van-overlay",
        {
          attrs: { show: _vm.show },
          on: {
            click: function ($event) {
              _vm.show = false
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "end" } },
            [
              _c("img", {
                staticStyle: { width: "300px", "padding-right": "10px" },
                attrs: { src: require("../../assets/image/weixinDiaolog.png") },
              }),
            ]
          ),
        ]
      ),
      _vm._m(0),
      _c(
        "div",
        {
          staticStyle: {
            "margin-top": "40px",
            "text-align": "center",
            "font-size": "18px",
            "font-weight": "500",
          },
        },
        [_vm._v("巴斯夫调漆宝")]
      ),
      _c(
        "div",
        {
          staticStyle: {
            "margin-top": "150px",
            display: "flex",
            "align-items": "center",
            "justify-content": "center",
          },
        },
        [
          _c(
            "van-button",
            {
              staticStyle: { width: "90%", "border-radius": "10px" },
              attrs: { color: "#1989fa", loading: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.openClient()
                },
              },
            },
            [_vm._v(" 打开客户端")]
          ),
        ],
        1
      ),
      _vm.systemType === "iOS"
        ? _c(
            "div",
            {
              staticStyle: {
                "margin-top": "20px",
                display: "flex",
                "align-items": "center",
                "justify-content": "center",
              },
            },
            [
              _c(
                "van-button",
                {
                  staticStyle: {
                    width: "90%",
                    "border-radius": "10px",
                    color: "#1989fa",
                  },
                  attrs: { icon: require("../../assets/image/ios.png") },
                  on: {
                    click: function ($event) {
                      return _vm.download(1)
                    },
                  },
                },
                [_vm._v("App Store")]
              ),
            ],
            1
          )
        : _c(
            "div",
            {
              staticStyle: {
                "margin-top": "20px",
                display: "flex",
                "align-items": "center",
                "justify-content": "center",
              },
            },
            [
              _c(
                "van-button",
                {
                  staticStyle: {
                    width: "90%",
                    "border-radius": "10px",
                    color: "#1989fa",
                  },
                  attrs: { icon: require("../../assets/image/android.png") },
                  on: {
                    click: function ($event) {
                      return _vm.download(2)
                    },
                  },
                },
                [_vm._v("安卓版下载")]
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          "margin-top": "120px",
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        },
      },
      [
        _c("img", {
          staticStyle: { width: "120px", "border-radius": "18px" },
          attrs: { src: require("../../assets/image/appLog.png") },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }